<template>
  <b-dropdown
      toggle-class="text-decoration-none"
      no-caret
      class="prk prk-dropdown"
      @shown="active = true"
      @hidden="active = false"
      right
      boundary="window"
      ref="dropdown"
  >
    <template v-slot:button-content>
      <span v-if="!active" text="show_options" class="prk-button">
        <base-icon width="16" height="5" :icon-color="iconColor">
          <icon-options/>
        </base-icon>
      </span>
      <span v-else class="prk prk-button">
        <base-icon width="16" height="5" :icon-color="iconColor">
          <icon-options/>
        </base-icon>
      </span>
    </template>
    <b-dropdown-item
        v-for="(option, index) in options"
        @click="option.action"
        :key="index"
    >
      {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import useIcon from '../composables/useIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'PrkIconOptions',
  setup (_, { root }) {
    const { iconOptions } = useIcon(root)
    return { iconOptions }
  },
  data () {
    return {
      active: false,
    }
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  watch: {
    contrast () {
      const { iconOptions } = useIcon(this.$root)
      this.iconOptions = iconOptions
    },
  },
  computed: {
    ...mapGetters('page', ['contrast']),
    iconColor () {
      return this.contrast ? '#00FA53' : '#00B4EB'
    },
  },
}
</script>

<style scoped lang="scss">
@import './app/javascript/prk/assets/stylesheets/vars';

::v-deep {
  &.dropdown.prk .btn {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
    padding: 0;

    &:focus {
      outline: 1px dotted;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }
}

span.prk-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $pcg-lightest-aqua-blue;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  padding: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: 0;
  &:hover {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }
}
</style>

<style scoped lang="scss">
@import './app/javascript/prk/assets/stylesheets/vars-contrast';

.contrast {
  .prk-button {
    ::v-deep {
      &.pcg-button {
        background-color: $pcg-dark-green !important;
      }
    }
  }
  .prk-dropdown.show {
    ::v-deep {
      .pcg-button {
        background: $hover-color;
      }
    }
  }
  span.prk-button {
    background-color: #003204;
  }
}
</style>
